/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { type AbstractControl, type ValidationErrors } from '@angular/forms';
import { type BaseRequestOptionsArgs, type HttpResponse, type Rest, HttpService } from '@dm/core';
import { type Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HomedirRuleCifsShareService {
    constructor(
        private http: HttpService,
    ) { }

    getBatchRest(vstoreId: string, parentID: string): Rest {
        const rest = this.http.makeUrl('CIFSHomedirRule.getBatch', undefined, true);
        if (vstoreId) {
            rest.setParams({ vstoreId });
        }
        if (parentID) {
            rest.setFilters([{
                field: 'parentID',
                matchMode: '::',
                value: parentID,
            }]);
        }
        return rest;
    }

    countRest(vstoreId: string, parentID: string): Rest {
        const rest = this.http.makeUrl('CIFSHomedirRule.count', undefined, true);
        if (vstoreId) {
            rest.setParams({ vstoreId });
        }
        if (parentID) {
            rest.setFilters([{
                field: 'parentID',
                matchMode: '::',
                value: parentID,
            }]);
        }
        return rest;
    }

    add(params: any, options?: BaseRequestOptionsArgs): Observable<HttpResponse> {
        const rest = this.http.makeUrl('CIFSHomedirRule.post');
        return this.http.post(rest, params, options);
    }

    modify(id: number | string, params: any, options?: BaseRequestOptionsArgs): Observable<HttpResponse> {
        const rest = this.http.makeUrl('CIFSHomedirRule.put').format(id);
        return this.http.put(rest, params, options);
    }

    remove(id: number | string, vstoreId?: string, options?: BaseRequestOptionsArgs): Observable<HttpResponse> {
        const rest = this.http.makeUrl('CIFSHomedirRule.delete').format(id);
        if (vstoreId) {
            rest.setParams({ vstoreId });
        }
        return this.http.delete(rest, options);
    }

    /**
     * Homedir映射规则校验
     */
    homedirMappingRuleValidator(control: AbstractControl): ValidationErrors | null {
        const value: string = control.value;
        if (!value) {
            return null;
        }
        const len = value.length;
        // 1、\只能出现一次
        if (value.split('\\').length - 1 > 1) {
            return { homedirMappingRule: true };
        }
        // 2、结尾不能是.和\
        const lastChar = value.charAt(len - 1);
        if (lastChar === '.' || lastChar === '\\') {
            return { homedirMappingRule: true };
        }
        // 3、首字符不能是\
        if (value.charAt(0) === '\\') {
            return { homedirMappingRule: true };
        }
        // 4、只有结尾才能是*
        if (value.indexOf('*') !== -1 && value.indexOf('*') < len - 1) {
            return { homedirMappingRule: true };
        }
        // 5、不包含\"/[]<>+:;,?|=@和空格中任意字符（包括制表符）
        const invalidReg = /[\"\/\[\]@<>\+:;,\t\?\=\| ]+/;
        const valid = !(invalidReg.test(value));
        return valid ? null : { homedirMappingRule: true };
    }
}
